import type { ReactNode } from 'react';
import { LanguageSwitcher } from '../lib/i18n/context';
import { useI18n } from '../lib/i18n/runtime';

/** Frame for signed-out pages (sign-in, invitation, password reset). */
export function PublicLayout({ title, children }: { title: string; children: ReactNode }) {
  const { t } = useI18n();
  return (
    <>
      <a className="skip-link" href="#main">
        {t('skip')}
      </a>
      <header className="app-header">
        <div className="app-header__bar">
          <p className="app-header__title">{t('productName')}</p>
          <LanguageSwitcher />
        </div>
      </header>
      <main id="main" className="app-main app-main--narrow" tabIndex={-1}>
        <h1>{title}</h1>
        <div className="card stack">{children}</div>
      </main>
    </>
  );
}
